<template>
  <div
    class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-6 py-8 px-2 md:px-0"
  >
    <!-- Left Sidebar -->
    <div class="order-2 md:order-1 md:col-span-3">
      <LeftsideBarVue />
    </div>

    <!-- Editorial Content -->
    <div
      class="order-1 md:order-2 md:col-span-9 bg-white p-6 md:p-8 rounded-xl shadow-md gsap-detail"
    >
      <div v-if="editorial">
        <!-- Header -->
        <div
          class="flex flex-col sm:flex-row sm:items-center gap-6 mb-6 gsap-header"
        >
          <!-- Profile Image -->
  <img
  :src="getImage(editorial.image_url)"
  @error="onImageError"
  alt="Editorial"
  class="w-48 h-48 md:w-56 md:h-56 object-cover rounded-md border-4 border-gray-100 ring-2 ring-gray-200"
/>



          <!-- Title Section -->
          <div>
            <h2
              class="text-2xl md:text-3xl font-extrabold text-gray-900 leading-tight"
            >
              {{ editorial.title }}
            </h2>

            <p class="mt-1 text-base md:text-lg text-gray-500 font-medium">
              {{ editorial.subtitle }}
            </p>

            <div class="mt-2 w-16 h-1 bg-gray-300 rounded"></div>
          </div>
        </div>

        <!-- Description -->
        <div class="gsap-desc">
          <p
            class="text-gray-700 text-base md:text-lg leading-relaxed md:leading-loose max-w-4xl"
          >
            {{ editorial.description }}
          </p>
        </div>
      </div>

      <!-- Loading -->
      <div v-else class="text-gray-500 font-medium text-center py-10">
        Loading...
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import LeftsideBarVue from "@/components/LeftsideBar.vue";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: "EditorialDetail",
  components: { LeftsideBarVue },

  data() {
    return {
      editorial: null,
    };
  },

  methods: {
    async fetchEditorialDetails() {
      const id = this.$route.params.id;
      this.editorial = null;
      window.scrollTo(0, 0);

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/editorials/${id}`
        );
        this.editorial = res.data;

        this.$nextTick(() => {
          this.animateEditorial();
        });
      } catch (err) {
        console.error("Failed to fetch editorial details:", err);
      }
    },

    animateEditorial() {
      // Reset previous triggers
      ScrollTrigger.getAll().forEach((t) => t.kill());

      gsap.from(".gsap-detail", {
        opacity: 0,
        y: 40,
        duration: 0.8,
        ease: "power2.out",
      });

      gsap.from(".gsap-header", {
        opacity: 0,
        y: 20,
        duration: 1,
        delay: 0.2,
      });

      gsap.from(".gsap-desc", {
        scrollTrigger: {
          trigger: ".gsap-desc",
          start: "top 85%",
          toggleActions: "play none none none",
        },
        opacity: 0,
        y: 30,
        duration: 1,
      });
    },

    getImage(img) {
      return require(`@/assets/images/${img}`);
    },

    onImageError(event) {
      event.target.src = "";
    },
  },

  mounted() {
    this.fetchEditorialDetails();
  },

  watch: {
    "$route.params.id": "fetchEditorialDetails",
  },
};
</script>
